"use strict";
document.addEventListener("readystatechange", function() {
  if (document.readyState === "complete") {
    // Select all search sections
    const searchSections = document.querySelectorAll(".ae--header-search-box");

    searchSections.forEach(section => {
      // Select elements within the current section
      const miniSearchBtn = section.querySelector(".ae--header-main_quick_search");
      const miniSearchInput = section.querySelector(".ae--header-input-search");
      const instantSearchForm = section.querySelector(".ae--instant-search");
      const instantSearchResult = section.querySelector(".ae--instant-search-result");
      const instantSearchResultList = section.querySelector(".ae--instant-search-result-list");
      const instantSearchResultMessage = section.querySelector(".ae--instant-search-result-message");
      const instantSearchAllResultsForm = section.querySelector(".ae--instant-search-all-results");

      miniSearchBtn.addEventListener("click", () => {
        if (isMobile() && !document.location.href.includes("/search")) {
          document.location.href = "/search";
        }
      });

      // Attach the event to the document and check if the click is inside the current section
      document.addEventListener("click", (event) => {
        if (
          event.target.closest(".ae--header-search-box") === section
        ) {
          if (
            event.target.classList.contains("ae--header-input-search") ||
            event.target.classList.contains("ae--header-main_quick_search")
          ) {
            event.preventDefault();
            event.stopImmediatePropagation();
            event.stopPropagation();
            if (!isMobile()) {
              miniSearchBtn.classList.add("is-focused");
              miniSearchInput.classList.add("is-open");
            }
          } else {
            miniSearchBtn.classList.remove("is-focused");
            miniSearchInput.classList.remove("is-open");
            closeInstantSearch();
            miniSearchInput.value = "";
          }
        }
      });

      miniSearchInput.addEventListener("input", window.debounce((event) => {
        instantSearch(event, section);
      }, 300));

      instantSearchForm.addEventListener("submit", (event) => {
        event.preventDefault();
        if (/^ *$/.test(miniSearchInput.value)) {
          instantSearchAllResultsForm.submit();
        } else {
          instantSearchForm.submit();
        }
      });

      function instantSearch(event, section) {
        const value = event.target.value.trim().toLowerCase();
        getInstantSearchResult(value, section);
      }

      function getInstantSearchResult(value, section) {
        const queryKey = value.replace(" ", "-").toLowerCase();
        const cachedResults = {};

        if (cachedResults[queryKey]) {
          renderInstantSearchResults(cachedResults[queryKey], value, section);
          return;
        }

        fetch(window.Shopify.routes.root + `search/suggest.json?q=${queryKey}&resources[type]=product&resources[options][unavailable_products]=show&resources[options][fields]=title,product_type,variants.title`)
          .then((response) => {
            if (!response.ok) {
              const error = new Error(response.status);
              closeInstantSearch();
              throw error;
            }
            return response.json();
          })
          .then((suggestions) => {
            renderInstantSearchResults(suggestions.resources.results.products, value, section);
          })
          .catch((error) => {
            closeInstantSearch();
            throw error;
          });
      }

      function renderInstantSearchResults(results, value, section) {
        if (results.length === 0) {
          instantSearchResultMessage.innerText = `Search for "${value}"`;
          instantSearchResultList.innerHTML = "";
          instantSearchResult.style.display = "block";
        } else {
          results = results.slice(0, 4);
          instantSearchResultList.innerHTML = "";
          instantSearchResultMessage.innerText = "";
          const resultHTML = results.map((result) => {
            return `<li>
              <a href="${result.url}">
                <img src="${result.image}" alt="${result.title}" width="50" height="50" />
                <h3>${result.title}</h3>
              </a>
            </li>`;
          }).join("");

          instantSearchResultList.innerHTML = resultHTML;
          instantSearchResult.style.display = "block";
        }
      }

      function closeInstantSearch() {
        instantSearchResultList.innerHTML = "";
        instantSearchResult.style.display = "none";
      }

      function isMobile() {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent);
      }
    });
  }
});


// "use restrict";
// document.addEventListener("readystatechange", function() {
//   if ( document.readyState === "complete" ) {
//     // mini search
//     const miniSearchBtn = document.querySelector(".ae--header-main_quick_search");
//     const miniSearchInput = document.querySelector(".ae--header-input-search");
//     miniSearchBtn.addEventListener("click", () => {
//       if(isMobile() && !document.location.href.includes("/search")) {
//           document.location.href="/search";
//       }
//     });

//     document.querySelector("body").addEventListener("click", (event) => {
//       if (
//         event.target.classList.contains("ae--header-input-search") ||
//         event.target.classList.contains("ae--header-main_quick_search")
//       ) {
//         event.preventDefault();
//         event.stopImmediatePropagation();
//         event.stopPropagation();
//         if(!isMobile()){
//           miniSearchBtn.classList.add("is-focused");
//           miniSearchInput.classList.add("is-open");
//         }
//       } else {
//         miniSearchBtn.classList.remove("is-focused");
//         miniSearchInput.classList.remove("is-open");
//         closeInstantSearch();
//         miniSearchInput.value = "";
//       }
//     });
//     // instant search
//     const cachedResults = {};
//     miniSearchInput.addEventListener("input", window.debounce((event) => {
//       instantSearch(event);
//     },300));

//     document.querySelector(".ae--instant-search").addEventListener("submit", (event) => {
//       event.preventDefault()
//       if (/^ *$/.test(document.querySelector(".ae--instant-search input").value)) {
//         document.querySelector(".ae--instant-search-all-results").submit();
//       } else {
//         document.querySelector(".ae--instant-search").submit();
//       }
//     });

//     function instantSearch(event) {
//       getInstantSearchResult(event.target.value.trim().toLowerCase());
//     }

//     function getInstantSearchResult(value) {
//       const queryKey = value.replace(" ", "-").toLowerCase();

//       if (cachedResults[queryKey]) {
//         renderInstanSearchResults(cachedResults[queryKey], value);
//         return;
//       }

//       fetch(window.Shopify.routes.root + `search/suggest.json?q=${queryKey}&resources[type]=product&resources[options][unavailable_products]=show&resources[options][fields]=title,product_type,variants.title`)
//       .then((response) => {
//         if (!response.ok) {
//           var error = new Error(response.status);
//           closeInstantSearch();
//           throw error;
//         }

//         return response.json();
//       })
//       .then((suggestions) => {
//         renderInstanSearchResults(suggestions.resources.results.products, value);
//       })
//       .catch((error) => {
//         closeInstantSearch();
//         throw error;
//       });
//     }

//     function renderInstanSearchResults(results, value) {
//       if ( results.length === 0 ) {
//         document.querySelector(".ae--instant-search-result-message").innerText = `Search for "${value}"`;
//         document.querySelector(".ae--instant-search-result-list").innerHTML = "";
//         document.querySelector(".ae--instant-search-result").style.display = "block";
//       } else {
//         results = results.slice(0,4);
//         document.querySelector(".ae--instant-search-result-list").innerHTML = "";
//         document.querySelector(".ae--instant-search-result-message").innerText = "";
//         const resultHTML = results.map((result) => {
//           return `<li>
//             <a href="${result.url}">
//               <img src="${result.image}" alt="${result.title}" width="50" height="50" />
//               <h3>${result.title}</h3>
//             </a>
//           </li>`;
//         }).join("");

//         document.querySelector(".ae--instant-search-result-list").innerHTML = resultHTML;
//         document.querySelector(".ae--instant-search-result").style.display = "block";
//       }
//     }

//     function closeInstantSearch() {
//       document.querySelector(".ae--instant-search-result-list").innerHTML = "";
//       document.querySelector(".ae--instant-search-result").style.display = "none";
//     }

//     function isMobile(){
//       return /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)
//     }
//   }
// })
